var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgDistinctiveIdentity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42.1 42.1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m21.087 0.083202c-1.9 0-3.4004 0.7-4.4004 2-2.4 3-1.3996 8.4004-0.59961 11.4 0.6 2.3 2.1 5.6004 3 7.4004 0.02 0.04 0.03955 0.07433 0.06055 0.11133-1.67 2.345-3.8613 6.3475-3.8613 11.688v8.7109c1.0049 0.28279 2.0397 0.49209 3.0996 0.62305v-9.334c0-3.6 1.2016-6.4988 2.6016-8.7988 1.4 2.3 2.5996 5.1988 2.5996 8.7988v9.334c1.0589-0.13068 2.0942-0.33903 3.0996-0.62109v-8.7129c0-5.23-2.1038-9.1838-3.7598-11.549a4.55 4.55 0 0 0 0.25977-0.35156c0.8-1.8 2.3004-5.0988 2.9004-7.2988 0.7-2.9 1.7004-8.4004-0.59961-11.4-1.1-1.3-2.5004-2-4.4004-2zm-0.09961 3.0996c1.2 0 1.5984 0.40039 1.8984 0.90039 1.1 1.4 1.1 4.6992 0 8.6992-0.3 1.1-0.99844 2.8008-1.8984 4.8008-0.7-1.6-1.5004-3.5004-1.9004-4.9004-1.1-4-1.1-7.2992 0-8.6992 0.3-0.4 0.80039-0.80078 1.9004-0.80078z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistinctiveIdentity);
export default __webpack_public_path__ + "static/media/distinctive_identity.c121619d095d505c554c471c9c30a1b1.svg";
export { ForwardRef as ReactComponent };